import { render, staticRenderFns } from "./shopIntro.vue?vue&type=template&id=65e16e7e&scoped=true"
import script from "./shopIntro.vue?vue&type=script&lang=js"
export * from "./shopIntro.vue?vue&type=script&lang=js"
import style0 from "./shopIntro.vue?vue&type=style&index=0&id=65e16e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e16e7e",
  null
  
)

export default component.exports